// Периоды «Активности»: 30 дней по дням, год и всё время по месяцам.
export const ACTIVITY_PERIODS = ["30d", "year", "all"] as const;

export type ActivityPeriod = (typeof ACTIVITY_PERIODS)[number];

// Без параметра в адресе — год.
export const DEFAULT_ACTIVITY_PERIOD: ActivityPeriod = "year";
